import { Component, EventEmitter, Output } from '@angular/core'
import { AdvancedSearchOption } from '../../types'
import { CommonModule } from '@angular/common'
import { TranslocoDirective } from '@jsverse/transloco'
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
   selector: 'app-search-selectbutton',
   standalone: true,
   imports: [CommonModule, FormsModule, TranslocoDirective],
   templateUrl: './search-selectbutton.component.html',
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         multi:true,
         useExisting: SearchSelectbuttonComponent
      }
   ]
})
export class SearchSelectbuttonComponent implements ControlValueAccessor {

   onChange!: (obj: AdvancedSearchOption | null) => void
   onTouched!: () => void
   disabled = false
   option!: AdvancedSearchOption

   writeValue(obj: AdvancedSearchOption): void {
      this.option = obj
   }
   registerOnChange(fn: (obj: AdvancedSearchOption | null) => void): void {
      this.onChange = fn
   }
   registerOnTouched(fn: () => void): void {
      this.onTouched = fn
   }
   setDisabledState?(isDisabled: boolean): void {
      this.disabled = isDisabled
   }

   @Output() selected = new EventEmitter<AdvancedSearchOption>()

   select() {
      this.selected.emit(this.option)

      if(this.option.selected === this.option.value) {
         this.option.selected = null
         this.onChange(null)

      } else {
         this.option.selected = this.option.value
         this.onChange(this.option)
      }
   }
}
